const consumptionUnits = {
  electric: ['kwh'],
  gas: ['ccf', 'cf', 'mcf', 'mmbtu', 'therms', 'dth'],
  water: ['ccf', 'cf', 'gal', 'kgal'],
  propane: ['gal', 'kbtu', 'mmbtu'],
  production: ['-'],
};

export default consumptionUnits;
